module.exports = "/_next/static/images/d987f9c9bdc7a571d4afa9be174c450e-credit-card-prepayment@2x.png";